package br.com.vvrefeicoes.portal.domain.model

data class OperationalSupplier(
    val id: String,
    val name: String,
    val categoryId: String,
)
